import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-unfold-less",
  templateUrl: "./med-icon-unfold-less.component.html",
})
export class MedIconUnfoldLessComponent extends SvgMixinComponent {}
